
// アイコン - ライブ
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: {
      type: String,
      default: '#000',
    },
  },
})
